import { HttpService } from 'core/modules/network-service';
import { get, forEach, find, isEmpty, merge } from 'lodash';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';

// get store
const store = getStore();

import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getLabel } from 'utils/getLabel';

/*************************************************************/

/**
 * @type {class}
 * @desc OrderDetailsPrescriptions defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { OrderDetailsPrescriptionsService } from 'services/orderDetailsPrescriptions';
 *
 * // create service instance and send/cancel request
 * const orderDetailsPrescriptionsService = new OrderDetailsPrescriptionsService();
 * const result = await orderDetailsPrescriptionsService.fetchData( '<user-id>' ); // fetch data
 * orderDetailsPrescriptionsService.cancel(); // cancel an active request
 */
export class OrderDetailsPrescriptionsService extends HttpService {

    // make request and fetch data
    async fetchData( { url, data } ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );

        // get ongoing callType info from the redux store
        const callType = get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null );

        // caller Type
        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                        callType,
                        callerType
                    },
                } ),
            } );

            const orderOption = get( response, 'body.component.data.options.orderStatus', [] );
            forEach( get( response, 'body.component.data.state.items', [] ), item => {
                    if( ! isEmpty( item.values.status.orderStatus ) ) {
                        item.values.status.orderStatus = getLabel( get( find( orderOption, val => val.name === item.values.status.orderStatus ), 'title', {} ) );
                    }
                    return item;
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} ),
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    async initNotes( { url, data } ) {
       try {
           const response = await this.post( {
               host: CONFIG.host,
               path: url,
               data,
           } );

           const actions = get( response, 'body.component.structure.actions', [] );
           const title = get( response, 'body.component.structure.title', '' );
           const widgets = get( response, 'body.component.structure.widgets', '' );
           const options = get( response, 'body.component.data.options', {} );
           const fields = get( response, 'body.component.structure.fields', '' );
           const formActions = get( response, 'body.component.structure.formActions', [] );

           return {
               status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
               data: { widgets, actions, title, options, fields, formActions },
           };
           
       } catch( errResponse ) {
           return this._errorFormatter( errResponse );
       }
    }

    // make request and fetch data
    async initiateMarkResolved( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
